import { FiGrid, FiTable, FiBarChart2 } from "react-icons/fi";

/**
 * Bandeau titre + KPIs + vues (sans header fixe — le nav global est dans MarketPageShell).
 */
export default function MarketPageHero({
  title,
  asOf,
  pills = [],
  view,
  setView,
  heatmapEnabled = false,
  viewLabels = {},
}) {
  const t = (k, fallback) => viewLabels[k] ?? fallback;

  return (
    <div className="td-headerContent">
      <div className="td-headLeft">
        <div className="td-headTitle">{title}</div>
        {asOf ? <div className="td-headSub">{asOf}</div> : null}
        {pills.length > 0 ? (
          <div className="td-controls" style={{ marginTop: 6 }}>
            {pills.map((p) => (
              <div key={p.label} className="td-pill">
                <span className="td-pillLabel">{p.label}</span>
                <b className={p.gold ? "td-gold" : undefined}>{p.value}</b>
              </div>
            ))}
          </div>
        ) : null}
      </div>

      {setView ? (
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
          <button
            type="button"
            className={`td-viewIconBtn${view === "flow" ? " active" : ""}`}
            onClick={() => setView("flow")}
            title={t("flow", "Vue Flow")}
            aria-pressed={view === "flow"}
          >
            <FiGrid />
          </button>
          <button
            type="button"
            className={`td-viewIconBtn${view === "table" ? " active" : ""}`}
            onClick={() => setView("table")}
            title={t("table", "Vue Table")}
            aria-pressed={view === "table"}
          >
            <FiTable />
          </button>
          {heatmapEnabled ? (
            <button
              type="button"
              className={`td-viewIconBtn${view === "chart" ? " active" : ""}`}
              onClick={() => setView("chart")}
              title={t("chart", "Vue Heatmap")}
              aria-pressed={view === "chart"}
            >
              <FiBarChart2 />
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
